import { render } from "./maintenance-chat-page.vue?vue&type=template&id=efa70bce&scoped=true"
import script from "./maintenance-chat-page.vue?vue&type=script&lang=js"
export * from "./maintenance-chat-page.vue?vue&type=script&lang=js"

import "./maintenance-chat-page.vue?vue&type=style&index=0&id=efa70bce&lang=scss"
import "./maintenance-chat-page.vue?vue&type=style&index=1&id=efa70bce&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa70bce"]])

export default __exports__